<template>
    <b-container fluid>
        <b-row>
            <b-col md="12">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 class="card-title">{{$t('externalUser.dashboard')}}</h4>
                    </template>
                    <template v-slot:body>
                        <b-overlay :show="loading">
                            <div class="message-body-center">
                                <template v-if="isProfileComplete">
                                    <b-row class="mt-2">
                                        <b-col md='10' offset-md='1'>
                                            <div>
                                                <b-carousel
                                                    id="carousel-no-animation"
                                                    style="text-shadow: 1px 1px 2px #333;"
                                                    fade
                                                    :interval="20"
                                                    no-animation
                                                    indicators
                                                    img-width="1400"
                                                    img-height="480"
                                                >
                                                    <span v-for="(data, index1) in datas.allEventList" :key="index1">
                                                        <b-carousel-slide img-blank img-alt="Blank image">
                                                            <p style="color:black;">{{$t('externalUser.event_name')}} : {{ ($i18n.locale === 'bn') ? data.event_info_bn : data.event_info }}</p>
                                                            <p style="color:black;">{{$t('externalUser.venue')}} : {{ ($i18n.locale === 'bn') ? data.location_bn : data.location }}</p>
                                                            <p style="color:black;">{{$t('externalUser.start_date')}} : {{ data.start_date | dateFormat }}</p>
                                                            <p style="color:black;">{{$t('externalUser.end_date')}} : {{ data.end_date | dateFormat }}</p>
                                                        </b-carousel-slide>
                                                    </span>
                                                </b-carousel>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-3">
                                        <b-col md="12">
                                            <iq-card>
                                                <template v-slot:body>
                                                    <b-row>
                                                        <b-col cols="4" class="custom-box-shadow">
                                                            <div class="bg-success p-3 rounded mb-3 text-center">
                                                                <h5 class="text-white d-block">
                                                                    {{ $t('externalUser.number_of_service')}}
                                                                </h5>
                                                                <b-spinner v-if="unitLoad" variant="primary" label="Spinning"></b-spinner>
                                                                <h2 v-else class="text-white">{{ $n(datas.totaService[0].serviceQuantity) }}</h2>
                                                            </div>
                                                        </b-col>
                                                        <b-col cols="4" class="custom-box-shadow">
                                                            <div class="bg-success p-3 rounded mb-3 text-center">
                                                                <h5 class="text-white d-block">
                                                                    {{ $t('externalUser.current_event')}}
                                                                </h5>
                                                                <b-spinner v-if="unitLoad" variant="primary" label="Spinning"></b-spinner>
                                                                <h2 v-else class="text-white">{{ $n(datas.currentEvent[0].currentEvent) }}</h2>
                                                            </div>
                                                        </b-col>
                                                        <b-col cols="4" class="custom-box-shadow">
                                                            <div class="bg-success p-3 rounded mb-3 text-center">
                                                                <h5 class="text-white d-block">
                                                                    {{ $t('externalUser.upcoming_event')}}
                                                                </h5>
                                                                <b-spinner v-if="unitLoad" variant="primary" label="Spinning"></b-spinner>
                                                                <h2 v-else class="text-white">{{ $n(datas.upcomingEvent[0].upcomingEvent) }}</h2>
                                                            </div>
                                                        </b-col>
                                                    </b-row>
                                                </template>
                                            </iq-card>
                                        </b-col>
                                    </b-row>
                                    <b-overlay :show="loader">
                                        <b-row>
                                            <b-col>
                                            <b-table-simple class="tg mt-3" bordered hover small caption-top responsive>
                                                <b-thead>
                                                <b-tr>
                                                    <b-th style="width:10%" class="text-center">{{ $t('globalTrans.sl_no') }}</b-th>
                                                    <b-th style="width:10%" class="text-center">{{ $t('externalUser.service_name') }}</b-th>
                                                    <b-th style="width:10%" class="text-center">{{ $t('externalUser.patient_category') }}</b-th>
                                                    <b-th style="width:10%" class="text-center">{{ $t('externalUser.benefit') }}</b-th>
                                                </b-tr>
                                                </b-thead>
                                                <b-tbody  v-for="(info, index) in datas.serviceCategory" :key="index" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                                                <b-td class="text-center">{{ $n(index + 1) }}</b-td>
                                                <b-td class="text-center">{{ ($i18n.locale === 'bn') ? info.service_name_bn : info.service_name }}</b-td>
                                                <b-td class="text-center">{{ ($i18n.locale === 'bn') ? info.category_name_bn : info.category_name }}</b-td>
                                                <b-td class="text-center">{{ ($i18n.locale === 'bn') ? info.benefit_bn : info.benefit }}</b-td>
                                                </b-tbody>
                                            </b-table-simple>
                                            </b-col>
                                        </b-row>
                                    </b-overlay>
                                  </template>
                                <template v-else>
                                    <p class="pb-2 pt-2 h5">
                                        <span class="text-danger"><i class="ri-alert-fill mr-2"></i> Before fillout this form, please complete your</span>
                                        <a href="/patient-panel/profile-edit" class=""> Profile </a>
                                    </p>
                                </template>
                            </div>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
    import { profileShow, dashboardPatientPanelApi } from '../api/routes'
    import { mapGetters } from 'vuex'

    export default {
        data () {
            return {
                loading: false,
                isProfileComplete: 0,
                datas: [],
                serviceQuantity: 0,
                currentEvent: 0,
                serviceCategory: 0,
                totaService: 0,
                unitLoad: false,
                loader: false

            }
        },
        created () {
            this.patientProfileCheck()
            this.getData()
        },
        computed: {
            ...mapGetters({
                panelObj: 'ExternalUser/panelObj'
            })
        },
        methods: {
            // imageLoadError () {
            //     this.dashboardData.ongoing_list[this.totalPromotionCount].attachment = '/images/not_found.png'
            // },
            async patientProfileCheck () {
                this.loading = true
                const result = await RestApi.getData(awarenessEventServiceBaseUrl, profileShow)
                this.loading = false
                if (result.success) {
                    this.isProfileComplete = 1
                } else {
                    this.isProfileComplete = 0
                }
            },
            async getData () {
                this.unitLoad = true
                this.loader = true
                const result = await RestApi.getData(awarenessEventServiceBaseUrl, dashboardPatientPanelApi)
                if (result.success) {
                    this.datas = result.data
                } else {
                    this.datas = []
                }
                this.unitLoad = false
                this.loader = false
            }
        }
    }
</script>
